import '@react-pdf-viewer/core/lib/styles/index.css';
import { ProgressBar, SpecialZoomLevel, Viewer, Worker } from "@react-pdf-viewer/core";
import { useStore } from "../../Context";

export default function PDFViewer ({ url }) {
    const { setError } = useStore()
    
    function renderError (error) {
        const pdfError = {};
        let description = '';
        
        switch (error.name) {
          case 'InvalidPDFException': description = 'El documento es invalido o esta corrupto'; break;
          case 'MissingPDFException': description = 'Documento no encontrado'; break;
          case 'UnexpectedResponseException': description = 'Servicio no disponible'; break;
          default: description = 'No se puede cargar el documento'; break;
        }
        
        pdfError.type = 'PDF Error';
        pdfError.description = description;
        
        setError(pdfError);
    
        return null;
    };
    
    
    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
            <Viewer
                defaultScale={SpecialZoomLevel.PageFit}
                fileUrl={url}
                httpHeaders={{ 'Access-Control-Allow-Origin': '*' }}
                renderError={renderError}
                renderLoader={(percentages) => (
                    <div style={{ width: '240px' }}>
                        <ProgressBar progress={Math.round(percentages)} />
                    </div>
                )}
            />
        </Worker>
    )
}